import './common';
import './responsive_slider';
import './share_buttons';

jQuery ('#content_body img').each(function() {
	var index;
	var src = $(this).attr('src');
	var index = src.indexOf('/files');
	if(index != -1){
		$(this).attr('src', src.substr(index, src.length));
	}
});

//Add noprint class to all wistia videos in report pages
var wistiaEmbed = $(".wistia_embed");
for(var i=0;i<wistiaEmbed.length;i++){
	wistiaEmbed.eq(i).addClass("noprint");
}